import { Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class RequestToBridgeService {
  constructor(
    private http: HttpClient,
  ) {}

  public get(urlRoute: string, paramsRequest: any): Observable<any> {
    if (!urlRoute) {
      throw new Error('URL não especificada');
    }

    if (!paramsRequest) {
      throw new Error('Parâmetros para a API não especificados');
    }

    const baseUrl = `https://web.hapolo.com.br/api_app/api/apis_aplicativo_ponte`;
    const ipSemPorta = this.obterHostDaApi().replace(':8890', '');
    const dadosJSON = JSON.stringify(paramsRequest);

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    const params = new HttpParams()
      .set('uri', urlRoute)
      .set('ip', ipSemPorta)
      .set('method', 'GET')
      .set('dados', dadosJSON);

    return this.http.get(baseUrl, { params, headers }).pipe(
      catchError((error) => {
        console.error('Erro na requisição para a ponte:', error);
        return of({ success: false });
      }),
    );
  }

  public post(urlRoute: string, paramsRequest: any): Observable<any> {
    if (!urlRoute) {
      throw new Error('URL não especificada');
    }

    if (!paramsRequest) {
      throw new Error('Parâmetros para a API não especificados');
    }

    const baseUrl = `https://web.hapolo.com.br/api_app/api/apis_aplicativo_ponte`;
    const ipSemPorta = this.obterHostDaApi().replace(':8890', '');

    const body = {
      uri: urlRoute,
      ip: ipSemPorta,
      dados: paramsRequest,
      timeout: 10,
    };

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http.post(baseUrl, body, { headers }).pipe(
      catchError((error) => {
        console.error('Erro na requisição POST para a ponte:', error);
        return of({ success: false });
      }),
    );
  }

  public obterHostDaApi(): string {
    const url = localStorage.getItem('url_padrao');
    if (url) {
      return url.replace('http://', '').replace('/', '');
    } else {
      return 'http://web.hapolo.com.br';
    }
  }
}
